/**
* Utility contains domain specific helper methods used across components
* */

import * as Scroll from 'react-scroll';
const scroller = Scroll.scroller;


/**
 * In the case of of an auto generated title, we need to check if the title exists and append the iteration
 *
 * @param productName
 * @param appendedString
 * @param it
 * @param productList
 */

export function checkTitleDupAndModify(productName: string, appendedString: string, it: number, productList: string[]) {
  let title = "";
  let isDuplicate = false;
  appendedString = appendedString ? ` ${appendedString}`: "";

  do {
    title = `${productName}${appendedString}${it > 1 ? ` ${it}` :""}`;

    if (productList.indexOf(title) === -1) {
      isDuplicate = false;
    } else {
      isDuplicate = true;
      it++;
    }
  }
  while (isDuplicate);
  return title;
};

export function scrollToObject(scrollToId: string | void, containerId?: string, ) {
  if (scrollToId) {
    scroller.scrollTo(scrollToId, {
      containerId: containerId,
      delay: 100,
      duration: 500,
      smooth: true,
      offset: -126
    });
  }
};
